<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
  <div class="container">
    <div *ngIf="order&&order.length>0; else NoOrderFound">
        <div class="row">
                  <div class="col-sm-4 col-md-12 col-lg-6 col-xl-6" *ngFor="let data of order  | paginate: { itemsPerPage: 6, currentPage: p }">
              <div class="card" style="margin-top: 5%">
                  <div class="card-header">
                    <p style="font-style: open sans ; color: #cb983f"><strong>Order Id : {{data.orderno}} </strong></p> 
                  </div>
                  <div class="row" style="padding: 10px">
                    <div class="col-sm-4 col-md-12 col-lg-6 col-xl-6">
                        <p style="font-style: open-sans; color:#cb983f">Date :  {{data.date}} </p>
                        <p style="font-style: open-sans; color:#cb983f">Order Amount:  {{data.payable}} </p>
                        <div style="font-style: open-sans; color:#cb983f">
                           <div *ngFor=" let da of ostatus">
                                <h5 *ngIf="da.id == data.status_id ">Status: {{da.name}}</h5>
                          </div> 
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-12 col-lg-6 col-xl-6">
                        <div class=row>
                          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <button class='btn btn-default btn-block' style="margin-top: 2%; margin-right: 1% "[routerLink]="['/manageprofile/orderdetail/',  data.orderno]" >Detail</button>
                          </div>
                          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <button class='btn btn-secondary btn-block' style="margin-top: 2% ; margin-right: 1%"  (click)="goForReorder(data.orderno)" >Reorder</button>   
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <button class='btn btn-success3 btn-block' style="margin-top: 1%; margin-right: 1%" *ngIf="(!(data.status_id == 9 || data.status_id == 7 ))" small (click)="cancelOrder(data.id,data.orderno)" >Cancel </button>  
                              </div>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          </div>
          <div class="col-12 text-right">
                <pagination-controls  (pageChange)="p = $event"></pagination-controls >
        </div>
        </div>
        </div>
        
        
      <ng-template #NoOrderFound style="color:red;">
          <div *ngIf="found == 0 && order.length == 0">
      <mat-card style="margin-top:10%" >
        <mat-card-content>
            <div class="row">
                <div class="col-sm-6" text-center >
                    <label style="color: #cb983f;font-size: 18px "> 
                        No Order Found  </label>   
                </div>
                <div class="col-sm-6" text-center >
                    <button  class="btn btn-success2 btn-block"  routerLink="/store/home">Continue Shopping</button> 
                </div>
              </div>
        </mat-card-content>
      </mat-card>

          </div>
    </ng-template>